import React from "react";
import QuestionItem from "./item";
import { deepEqual } from "../../utils/object";
import { richTextPlainText } from "../rich-text";

class Questions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data ?? {}
        }
        this.questions = {};
        this.generateRefs();
    }

    generateRefs = () => {
        this.props.items?.forEach((item) => {
            this.questions[item.key] = React.createRef();
        });
    }

    componentDidUpdate = (oldProps) => {
        if (!deepEqual(this.props.items, oldProps?.items)) {
            this.generateRefs();
        }

        // Use reference equality here since parent creates new references on change
        if (!deepEqual(this.state.data, this.props.data ?? {})) {
            this.setState({
                data: this.props.data
            });
        }
        
    }
    
    getData = () => {
        const result = { ...(this.state.data ?? {}) };
        this.props.items?.forEach((item) => {
            if (this.questions[item.key].current) {
                const data = this.questions[item.key].current.getData();
                if (typeof data !== "undefined") {
                    result[item.key] = data;
                }
            }
        });
        return result;
    }
    
    onChange = () => {
        // Just notify parent that something changed
        if (this.props.onChange) {
            this.props.onChange();
        }
    }

    data = (key) => {
        try {
            return this.state.data[key];
        } catch {
            return undefined;
        }
    } 

    render() {
        if (!this.props.items) return null;

        return (
            <>
                {this.props.items.map(item => {
                    const validationError = (this.props.validationErrors || []).find(
                        error =>
                            error.sectionKey === this.props.sectionKey
                            && error.questionKey === item.key
                    );
                    const id = `survey-question-${this.props.sectionKey}-${item.key}`
                        .replace(/[^A-Za-z0-9_-]/g, "-");
                    return (
                        <div
                            key={item.key}
                            id={id}
                            className={validationError ? "fera-question-error" : undefined}
                            role="group"
                            aria-label={`${this.props.richTextLabels ? richTextPlainText(item.label) : item.label || "Survey question"}${item.required ? " (required)" : ""}`}
                            aria-describedby={validationError ? `${id}-error` : undefined}
                            tabIndex={validationError ? "-1" : undefined}
                        >
                            <QuestionItem
                                ref={this.questions[item.key]}
                                {...item}
                                element={item.key}
                                data={this.data(item.key)}
                                parent={this.state.data}
                                onChange={(e, simple = false) => this.onChange(e, item.key, simple)}
                                allowDynamicDisplay={this.props.allowDynamicDisplay}
                                collectionSections={this.props.collectionSections}
                                richTextLabels={this.props.richTextLabels}
                            />
                            {validationError ? (
                                <p
                                    id={`${id}-error`}
                                    className="text-danger fw-semibold"
                                    role="alert"
                                >
                                    {validationError.message}
                                </p>
                            ) : null}
                        </div>
                    );
                })}
            </>
        );
    }
}

export default Questions;
